<template>
  <div style="position: relative;">
    <div class="search-container">
      <el-row class="revise">
        <div class="search-bar notMobile">
          <div style="display:flex;width: 80%;">
            <div style="margin-right:15px;">
              <el-select v-model="form.date" class="mobile-select" style="width:150px;">
                <el-option v-for="(date,index) in dateList" :key="index" :label="date" :value="date"></el-option>
              </el-select>
            </div>
            <div style="margin-right:15px;">
              <el-select v-model="form.status" class="mobile-select" style="width:150px;">
                <el-option v-for="(status,index) in statusList" :key="index" :label="status.label" :value="status.name"></el-option>
              </el-select>
            </div>
            <div v-if="isSingle" style="margin-right:15px;">
              <el-select
                v-model="searchMerchant"
                clearable
                filterable
                :filter-method="filterSearch"
                class="input-width"
                @change="handleAutoSelect"
                placeholder="商家">
                <el-option
                  v-for="item in merchantOptions"
                  :key="item.id"
                  :label="item.value"
                  :value="item.id"></el-option>
              </el-select>
            </div>
            <div style="margin-right:15px;">
              <el-input v-model="merchant_account_name" placeholder="账号" style="width:250px;">
                <!--<span style="cursor:pointer" @click="handleTransportStatus" slot="append">&nbsp;&nbsp;搜索&nbsp;&nbsp;</span>-->
              </el-input>
              <!--<el-select v-model="merchant_account_name" @change="handleTransportStatus" style="width:150px;">
                <el-option
                  v-for="item in merchant_account_options"
                  :key="item.id"
                  :label="item.value"
                  :value="item.id">
                </el-option>
              </el-select>-->

            </div>
            <div v-if="merchant_account_name && searchMerchant" style="position: relative;width: 230px;">
              <el-button :title="lastUpdatedTime" class="block" type="info" :disabled="isUpdating" @click="updateMerchantOrderAndTime" style="height: 40px;width: 100px;">
                {{timeDisplay?timeDisplay+'秒':'同步订单'}}
              </el-button>
              <div v-if="updatingErrorShow" style="position: absolute;margin-top:5px;color:#e6a23c">{{updatingErrorMsg}}</div>
            </div>
          </div>
          <div>
            <el-button type="info" @click="setNewOrderVisible" native-type="button">
              新增订单
            </el-button>
          </div>
        </div>
        <div class="search-bar isMobile">
          <div style="margin-right:15px;">
            <el-select v-model="form.date" class="mobile-select" style="width:150px;">
              <el-option v-for="(date,index) in dateList" :key="index" :label="date" :value="date"></el-option>
            </el-select>
          </div>
          <div style="margin-right:15px;">
            <el-select v-model="form.status" class="mobile-select" style="width:150px;">
              <el-option v-for="(status,index) in statusList" :key="index" :label="status.label" :value="status.name"></el-option>
            </el-select>
          </div>
          <div v-if="isSingle" style="margin-right:15px;">
            <el-select
              v-model="searchMerchant"
              clearable
              filterable
              :filter-method="filterSearch"
              class="input-width"
              @change="handleAutoSelect"
              placeholder="商家">
              <el-option
                v-for="item in merchantOptions"
                :key="item.id"
                :label="item.value"
                :value="item.id"></el-option>
            </el-select>
          </div>
          <div style="margin-right:15px;">
            <el-input v-model="merchant_account_name" placeholder="账号" style="width:250px;">
            </el-input>
          </div>
          <div v-if="merchant_account_name && searchMerchant" style="position: relative;width: 230px;">
            <el-button :title="lastUpdatedTime" class="block" type="info" :disabled="isUpdating" @click="updateMerchantOrderAndTime" style="height: 40px;width: 100px;">
              {{timeDisplay?timeDisplay+'秒':'同步订单'}}
            </el-button>
            <div v-if="updatingErrorShow" style="position: absolute;margin-top:5px;color:#e6a23c">{{updatingErrorMsg}}</div>
          </div>
          <div>
            <el-button type="info" @click="setNewOrderVisible" native-type="button">
              新增订单
            </el-button>
          </div>
        </div>        
        <div class="search-bar notMobile">
          <span>{{totalCount}}个订单&nbsp;&nbsp;
          </span>
          <div style="width: 50%;display: flex;align-items: center;">
            <span v-if="role==1 || single_type==2" class="export" @click="exportExcel">{{ isExporting?'导出中':'导出excel' }}</span>
            <el-input style="flex:1" placeholder="搜索订单" v-model="searchWord" onkeyup="this.value=this.value.replace(/(^\s*)|(\s*$)/g,'')">
              <span style="cursor:pointer" @click="search()" slot="append">&nbsp;&nbsp;搜索&nbsp;&nbsp;</span>
            </el-input>
          </div>         
        </div>
        <div class="isMobile">
          <div class="search-bar">
            <span v-if="role==1 || single_type==2" class="export" @click="exportExcel">{{ isExporting?'导出中':'导出excel' }}</span>
            <el-input style="flex:1" placeholder="搜索订单" v-model="searchWord" onkeyup="this.value=this.value.replace(/(^\s*)|(\s*$)/g,'')">
              <span style="cursor:pointer" @click="search()" slot="append">&nbsp;&nbsp;搜索&nbsp;&nbsp;</span>
            </el-input>
          </div> 
          <div class="search-bar">
            <span>
              {{totalCount}}个订单&nbsp;&nbsp;
            </span>
          </div>
        </div>
      </el-row>
    </div>
    <div v-if="orders && totalCount > 0" class="orders-container">
      <Order
        v-on:Modify="Modify"
        :bussinessList="bussinessList"
        :singleList="singleList"
        :order="order"
        :isSingle="isSingle"
        v-for="(order,index) in orders"
        :key="index" @refresh="updatePriceInfo" @searchBuyer="searchBuyer">
      </Order>
    </div>
    <div class="yd-pagination" v-if="totalCount / form.limit > 1">
      <el-pagination
        :page-size="form.limit"
        :pager-count="5"
        :current-page.sync="form.page"
        layout="prev, pager, next"
        next-text="下一页"
        prev-text="上一页"
        :total="totalCount">
      </el-pagination>
    </div>
    <div v-if="totalCount === 0 && havKeyword" class="empty-orders-container">
      <Loading v-if="!orders"></Loading>
      <p v-if="totalCount === 0 && havKeyword">没有符合条件的订单。</p>
    </div>
    <el-dialog class="el-dialog-sm" :visible.sync="dialogFormVisible">
      <h3 class="text-center">新增商家订单</h3>
      <p class="error-messages" v-if="newOrderError">
        {{newOrderError}}
      </p>
      <div class="form-row">
        <el-autocomplete
          style="height: 50px;width:100%;"
          v-model="newOrderForm.joyorders_merchant_name"
          :fetch-suggestions="queryMerchantSearch"
          placeholder="商家" @change="checkValid" @select="handleMerchantAutoSelect"
        ></el-autocomplete>
      </div>
      <div class="form-row" style="margin:10px 0;">
        <el-input class="customHeightInput" placeholder="商家订单号" v-model="newOrderForm.merchant_order_no" @input="checkValid">         
        </el-input>
      </div>
      <div class="form-row">
        <!--<el-select v-model="newOrderForm.merchant_email" style="width:100%;" placeholder="选择商家账号" @change="checkValid">
          <el-option
            v-for="item in neworder_merchantemails"
            :key="item.id"
            :label="item.value"
            :value="item.id">
          </el-option>
        </el-select>-->
        <el-input class="customHeightInput" v-model="newOrderForm.merchant_email" placeholder="商家账号/邮箱" @input="checkValid"></el-input>
      </div>
      <div style="margin-top:20px;">
        <el-button :disabled="disableNewOrder" :loading="newOrderLoading" style="margin-bottom:20px;" class="block" type="primary" @click="addNewOrder()">保 存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Order from './Order'
import api from '../../../services/api.js'
import { TransportStatus } from '../../../services/constant.js'
import Loading from '../../../components/Loading'
let _ = require('lodash')

export default {
  name: 'Orders',
  props: ['type', 'isSingle'],
  components: {
    Order: Order,
    Loading: Loading
  },
  created () {
    this.keyword = this.$route.query.order_no
    this.form.page = Number(this.$route.query.page || 1)
    this.form.status = 'all'
    this.role = this.$localStorage.get("role")
    this.buyer_id=this.$localStorage.get("select_buyer_id")?this.$localStorage.get("select_buyer_id"):''
    this.getGroupBussinessList()
    this.getOrdersMerchants()
    //this.getSingleList()
    this.getEarliestDate()
  },
  data () {
    return {
      newOrderError:'',
      timeDisplay:0,
      isUpdating:false,
      lastUpdatedTime:'',
      role:0,
      merchantOptions:[],
      bigobj_merchantaccounts:{},
      neworder_merchantemails:[],
      dialogFormVisible:false,
      newOrderForm: {
        joyorders_merchant_id: '',
        joyorders_merchant_name:'',
        merchant_email:'',
        merchant_order_no:''
      },
      disableNewOrder:true,
      newOrderLoading:false,
      form: {
        date: '最近3个月',
        to_date: null,
        from_date: null,
        status: '',
        page: 1,
        limit: 10
      },
      dateList: [
        '最近30天',
        '最近3个月',
        '最近6个月'
      ],
      keyword: null,
      totalCount: null,
      orders: null,
      bussinessList: null,
      singleList: null,
      havKeyword: false,
      searchWord: null,
      searchMerchant:'',
      merchant_account_options:[],
      merchant_account_name:'',
      transport_status:-1,
      buyer_id:'',
      buyers:[],
      searchMerchantInfo:{},
      transportStatusArray:TransportStatus,
      merchants:[],
      updatingErrorShow:false,
      updatingErrorMsg:'',
      single_type:this.$localStorage.get('single_type'),
      isExporting:false,
      statusList: [
        {label: '订单状态', name: 'all'},
        {label: '未知', name: '0'},
        {label: '处理中', name: '15'},
        {label: '已发货', name: '16'},
        {label: '已取消', name: '30'},
        {label: '联系客服', name: '40'},
        {label: '已退货', name: '50'},
        {label: '部分发货', name: '60'},
      ],
    }
  },
  methods: {
    exportExcel(){
      this.isExporting=true
      if (!this.keyword) {
        this.havKeyword = false
      } else {
        this.havKeyword = true
      }
      if (this.searchWord) {
        this.keyword = this.searchWord
      } else {
        this.keyword = null
      }
      this.getOrders(true)
    },
    setNewOrderVisible(){
      this.dialogFormVisible=true;
    },
    async addNewOrder(){
      this.newOrderError=''
      this.newOrderLoading=true;
      let res = await api.post(this, {
            path: 'merchant_order.php',
            api: 'realtime_crawling',
            data: this.newOrderForm,
            loading: 'loading'
          })
      res = res.body
      this.newOrderLoading=false;
      if(res.result=='success'){
        this.getOrders()
        this.getOrdersCount()
        this.dialogFormVisible=false;
      }
      else
        this.newOrderError=res.result;
    },
    async queryMerchantSearch(queryString, cb){
      let query = {
        keyword: queryString
      }
      let res = await api.searchBusiness(this,query)
      let arr = []
      res.body.result.forEach(item => {
        arr.push({value:item.name,id:item.id,currency:item.default_currency})
      })
      cb(arr)
    },
    handleMerchantAutoSelect(item){
      this.newOrderForm.joyorders_merchant_id=+item.id;
      //this.neworder_merchantemails=this.bigobj_merchantaccounts[this.newOrderForm.joyorders_merchant_id]
      if(this.newOrderForm.joyorders_merchant_id && this.newOrderForm.merchant_order_no && this.newOrderForm.merchant_email)
        this.disableNewOrder=false;
      else
        this.disableNewOrder=true;
    },
    checkValid(){
      if(this.newOrderForm.joyorders_merchant_id && this.newOrderForm.merchant_order_no && this.newOrderForm.merchant_email)
        this.disableNewOrder=false;
      else
        this.disableNewOrder=true;
    },
    updateMerchantOrderAndTime(){
      this.isUpdating=true;
      let params={joyorders_merchant_id: this.searchMerchant,account_name:this.merchant_account_name}

      api.post(this, {
              path: 'merchant_order.php?api=add_crawler_process',
              data: params,
              })
        .then((res)=>{
          if (res.body.status == 'ok') {
            this.timeDisplay=+res.body.result;
            let handler=setInterval(()=>{
              if(this.timeDisplay>0)
                this.timeDisplay--;
              else{
                this.isUpdating=false;
                clearInterval(handler)
              }
            },1000)
          }
          else{
            this.updatingErrorShow=true;
            this.updatingErrorMsg=res.body.result
            setTimeout(()=>{
              this.updatingErrorMsg=''
              this.updatingErrorShow=false;
            },5000)
            this.isUpdating=false;
          }
        })
      //this.getUpdateTime();
    },
    getUpdateTime(){
      //this.isUpdating=true;
      let params={joyorders_merchant_id: this.searchMerchant,account_name:this.merchant_account_name}
      api.get(this, {
              path: 'merchant_order.php?api=get_last_update_time',
              params: params,
              })
        .then((res)=>{
          if (res.body.status == 'ok' && res.body.result) {
            this.lastUpdatedTime='上次同步于'+res.body.result+"，点击同步";
          }
          //this.isUpdating=false;
        })
    },
    updatePriceInfo(data){
      data.order.price_info=data.price_info;
    },
    handleTransportStatus(){
      if(this.searchMerchant && this.merchant_account_name)
        this.getUpdateTime();
      if (this.form.page != 1) {
        this.form.page = 1
      } else {
        //this.getOrdersMerchants()
        this.getOrders()
        this.getOrdersCount()
        //this.getBuyers();
      }
    },
    removeSearchMerchant(value){
      if(!value.target.value){
        this.searchMerchantInfo={};
        if (this.form.page != 1) {
          this.form.page = 1
        } else {
          //this.getOrdersMerchants()
          this.getOrders()
          this.getOrdersCount()
          //this.getBuyers();
        }
      }
    },
    handleAutoSelect(item){
      this.searchMerchant=item;
      //this.getMerchantOrderAccount()
      if(!item)
        this.filterMerchantAccounts('all')
      else
        this.filterMerchantAccounts(item)
      if(this.searchMerchant && this.merchant_account_name)
        this.getUpdateTime();
      if (this.form.page != 1) {
        this.form.page = 1
      } else {
        //if(!item)
        //  this.getOrdersMerchants()
        this.getOrders()
        this.getOrdersCount()
        //this.getBuyers();
      }
    },
    filterSearch(val){
      this.merchantOptions = []
      let mers=[];
      if(val){
        mers=this.merchants.filter((item)=>{
          return item.merchant_name.toLowerCase().indexOf(val.toLowerCase())>-1
        })
      }
      else{
        mers=this.merchants;
      }
      mers.forEach(item => {
        this.merchantOptions.push({value:item.merchant_name,id:item.merchant_id})
      })
    },
    async querySearch(queryString, cb){
      let arr = []
      let mers=[];
      if(queryString){
        mers=this.merchants.filter((item)=>{
          return item.merchant_name.toLowerCase().indexOf(queryString.toLowerCase())>-1
        })
      }
      else{
        mers=this.merchants;
      }
      mers.forEach(item => {
        arr.push({value:item.merchant_name,id:item.merchant_id})
      })
      cb(arr)
    },
    async getOrders (isExport) {
      let method = isExport?'exportSingleOrders':'getMerchantOrders'
      if(!isExport)
        this.orders = null
      let query = this.createQuery(isExport)
      let res = await api[method](this, query)
      if(isExport){
        this.isExporting=false
        const href=window.URL.createObjectURL(new Blob([res.body],{type:'application/octet-stream'}))
        const link=document.createElement('a')
        link.href=href
        let name='MerchantOrderList'
        let today=new Date()
        name+=today.getFullYear()+(today.getMonth()+1<10?('0'+(today.getMonth()+1)):(today.getMonth()+1))+(today.getDate()<10?'0'+today.getDate():today.getDate())
        let random=Math.random()+''
        random=random.substring(random.indexOf('.')+1,random.indexOf('.')+4)
        name+=random
        link.download=name+'.xlsx'
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      }
      else{
        res = res.body
        this.orders = res.result
        _.each(this.orders, order => {
          order.address_info = order.address || {}
          if(order.remark){
            let tempArr=order.remark.split('| ');
            order.iconTitle=tempArr[0];
            if(tempArr.length>1)
              order.realRemark=tempArr[1];
            else
              order.realRemark=order.remark;
          }
          if(order.status<=15){
            order.displayVoucherList=order.voucher_list.filter(voucher=>voucher.type==4)
          }
          !(order.fee_adjustment_list[0] && (order.fee_adjustment_list[0].unpaid_fee_rmb && order.fee_adjustment_list[0].status != 4))
          if(order.fee_adjustment_list.length){
            order.noNeedPaid=true;
            for(let i=0,length=order.fee_adjustment_list.length;i<length;i++){
              if(order.fee_adjustment_list[i].offline_payment==0 && order.fee_adjustment_list[i].unpaid_fee_rmb 
              && (order.fee_adjustment_list[i].status==0 || order.fee_adjustment_list[i].status==3))
                order.noNeedPaid=false;
                break;
            }
          }
          else{
            order.noNeedPaid=true
          }
        })
        this.$router.push(
          {
            path: this.$route.path,
            query: {
              type: this.$route.query.type,
              page: this.form.page,
              order_no: this.$route.query.order_no
            }
          }
        )
      }
    },
    createQuery (isExport) {
      let query = Object.assign({}, this.form)
      if(isExport){
        delete query.page
        delete query.limit
        query.need_export=1
      }
      delete query.date
      if(this.form.status=='all')
        query.status=''
      query.keyword = this.keyword?this.keyword.replace(/ /g,''):this.keyword

      let now = +new Date()
      let past
      let day = 24 * 3600 * 1000
      if (this.form.date === '最近30天') {
        past = now - 30 * day
      } else if (this.form.date === '最近3个月') {
        past = now - 90 * day
      } else if (this.form.date === '最近6个月') {
        past = now - 180 * day
      } else {
        past = this.form.date + '-01-01'
        now = this.form.date + '-12-31'
      }

      query.from_date = this.$moment(past).format('YYYY-MM-DD')
      query.to_date = this.$moment(now).format('YYYY-MM-DD')

      /*if(this.searchMerchantInfo && this.searchMerchantInfo.id){
        query.merchant_id=this.searchMerchantInfo.id;
      }*/
      if(this.searchMerchant){
        query.merchant_id=this.searchMerchant;
      }
      if(this.merchant_account_name){
        query.merchant_account_name=this.merchant_account_name;
      }
      if(this.transport_status>-1){
        query.transport_status=this.transport_status;
      }
      if (this.$route.query.order_no) {
        query.from_date = null
        query.to_date = null
      }

      return query
    },
    async getOrdersCount () {
      let method = 'getMerchantOrdersCount'
      let query = this.createQuery()
      let res = await api[method](this, query)
      res = res.body
      this.totalCount = Number(res.result)
      let data = {
        totalCount: this.totalCount,
        havKeyword: this.havKeyword
      }
      // if (!this.keyword) {
      this.$emit('totalCount', data)
      // }
    },
    async getOrdersMerchants () {
      let res = await api.getMerchants(this)
      res = res.body
      this.merchants = res.result
      this.merchantOptions=[]
      this.bigobj_merchantaccounts={};
      this.merchantOptions.push({value:'商家',id:''})
      this.merchants.forEach(item => {
        this.merchantOptions.push({value:item.merchant_name,id:item.merchant_id})
        this.bigobj_merchantaccounts[item.merchant_id]=[];
      })
      this.bigobj_merchantaccounts['all']=[]
      this.getMerchantOrderAccount()
    },
    async getMerchantOrderAccount () {
      let res = await api.getMerchantOrderAccount(this)
      let t= res.body.result
      t.forEach(item => {
        this.bigobj_merchantaccounts[item.merchant_id]=item.account_list.map((i)=>{return {value:i,id:i}})
        this.bigobj_merchantaccounts['all']=this.bigobj_merchantaccounts['all'].concat(item.account_list)
      })
      this.bigobj_merchantaccounts['all']=this.unique(this.bigobj_merchantaccounts['all']).map((i)=>{return {value:i,id:i}})
      this.filterMerchantAccounts('all')
      //this.merchant_account_name=''
    },
    unique(arr) {
      return Array.from(new Set(arr))
    },
    filterMerchantAccounts(merchant_id){
      this.merchant_account_options=[]
      this.merchant_account_options.push({value:'账号',id:''})
      this.merchant_account_options=this.merchant_account_options.concat(this.bigobj_merchantaccounts[merchant_id])
    },
    async getGroupBussinessList () {
      let res = await api.getGroupBussinessList(this, {setLs: true, getLs: true,getLsTime: new Date().getTime()})
      let result = res.body.result
      this.bussinessList = _.groupBy(result, 'id')
    },
    async getEarliestDate () {
      let res = await api.getEarliestDate(this, {
        type: this.isSingle ? 'by_single' : 'by_buyer',
        account_id: this.$localStorage.get('account_id')
      })
      let result = (res.body.result || '').replace(/-/g, '/') || new Date()
      result = new Date(result).getFullYear()
      let currentYear = new Date().getFullYear()

      while (currentYear >= result) {
        this.dateList.push(currentYear)
        currentYear--
      }
    },
    searchBuyer(data){
      this.merchant_account_name=data;
      this.search()
    },
    search () {
      if(this.searchMerchant && this.merchant_account_name)
        this.getUpdateTime();
      if (!this.keyword) {
        this.havKeyword = false
      } else {
        this.havKeyword = true
      }
      this.totalCount = null
      if (this.searchWord) {
        this.keyword = this.searchWord
      } else {
        this.keyword = null
      }
      if (this.form.page != 1) {
        this.form.page = 1
      } else {
        //this.getOrdersMerchants()
        this.getOrders()
        this.getOrdersCount()
        //this.getMerchantOrderAccount();
      }
    },
    Modify () {
      //this.getOrdersMerchants()
      this.getOrders()
      this.getOrdersCount()
      //this.getMerchantOrderAccount();
    }
  },
  watch: {
    form: {
      handler: function (val, oldVal) {
        //this.getOrdersMerchants()
        this.getOrders()
        this.getOrdersCount()
        //this.getMerchantOrderAccount();
      },
      deep: true
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .export{
    margin-right:13px;
  }
  .export:hover{
    text-decoration: underline;
    cursor: pointer;
  }
  .search-bar{
    display:flex;
    width:100%;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
  }
  .revise {
    display:  inline-block;
    width: 100%;
  }
.empty-orders-container {
  font-size:16px;
  color:rgba(102,102,102,1);
  line-height:22px;
  text-align: center;
  padding: 133px 0 200px
}
.yd-pagination {
  position: absolute;
  bottom: -70px;
  width: 100%;
}
.error-messages{
  text-align: center;
  color: #ff4650;
  line-height: 17px;
  margin-bottom: 10px;
}
.el-input__inner{
  height:50px!important;
}
@media screen and (min-width: 961px) {
  .search-bar.notMobile{
      display: flex !important;
    }
    .isMobile {
      display: none !important;
    }
}
  @media screen and (max-width: 960px) {
    .search-bar.notMobile{
      display: none !important;
    }
    .isMobile {
      display: block !important;
    }
    .search-bar.isMobile{
      display: flex !important;
      flex-wrap: wrap;
    }
    .search-bar>div{
      margin-right:13px;
      margin-bottom: 10px;
    }
    .mobile-select {
      width: 60%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/merchantOrders/list/Orders.vue